// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"50d860eccbb924d0","8982":"be282bd3e33c20e3"}[chunkId] + ".css";
};